import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const saved = localStorage.getItem("theme") || "light";
    setTheme(saved);
    document.documentElement.setAttribute("data-theme", saved);
  }, []);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("theme", next);
  };

  const closeMobileMenu = () => {
    setMobileOpen(false);
    setServicesOpen(false);
  };

  const phone = "+919954129808";

  return (
    <>
      <header className="top-navbar">
        {/* LEFT: LOGO */}
        <div className="nav-left">
          <div className="logo-land">PrimeMax</div>
        </div>

        {/* DESKTOP NAV */}
        <nav className="nav-right">
          {/* SERVICES (DESKTOP MEGA MENU) */}
          <div className="nav-mega">
            <span className="nav-link">SERVICES ▾</span>
            <div className="hover-bridge" />

            <div className="mega-panel">
              <div className="mega-inner">
                <div className="mega-col">
                  <h4>General & Restorative</h4>
                  <a href="#">Dental Implants</a>
                  <a href="#">Crown & Bridge</a>
                  <a href="#">Tooth Extraction</a>
                  <a href="#">Full Mouth Reconstruction</a>
                </div>

                <div className="mega-col">
                  <h4>Cosmetic</h4>
                  <a href="#">Teeth Whitening</a>
                  <a href="#">Veneers</a>
                  <a href="#">Smile Makeover</a>
                  <a href="#">Cosmetic Dentistry</a>
                </div>

                <div className="mega-col">
                  <h4>Endodontics & Gum</h4>
                  <a href="#">Painless Root Canals</a>
                  <a href="#">Advanced Gum Treatments</a>
                  <a href="#">Periodontal Care</a>
                </div>

                <div className="mega-col">
                  <h4>Other</h4>
                  <a href="#">Child Dentistry</a>
                  <a href="#">Digital X-Ray</a>
                  <a href="#">Dentures</a>
                  <a href="#">Cleaning & Polishing</a>
                </div>

                <div className="mega-col mega-cta">
                  <h4>Book & Contact</h4>
                  <Link to="/book" className="btn-cta">Book Now</Link>
                  <p className="mega-note">
                    Call us: <strong>{phone}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <Link className="nav-link" to="/book">BOOK NOW</Link>
          <Link className="nav-link" to="/careers">CAREERS</Link>
          <a className="nav-link" href={`tel:${phone}`}>CONTACT US</a>

          <button className="theme-toggle-btn" onClick={toggleTheme}>
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
        </nav>

        {/* HAMBURGER (RIGHT SIDE) */}
        <button
          className="hamburger"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰
        </button>
      </header>

      {/* MOBILE MENU */}
      {mobileOpen && (
        <div className="mobile-menu">
          <Link to="/book" onClick={closeMobileMenu}>Book Now</Link>

          <button
            className="mobile-accordion"
            onClick={() => setServicesOpen(!servicesOpen)}
          >
            Services {servicesOpen ? "▲" : "▼"}
          </button>

          {servicesOpen && (
            <div className="mobile-sub">
              {[
                "Dental Implants",
                "Cosmetic Dentistry",
                "Teeth Whitening",
                "Painless Root Canals",
                "Advanced Gum Treatments",
                "Periodontal Care",
                "Veneers",
                "Smile Makeover",
                "Crown & Bridge",
                "Tooth Extraction",
                "Full Mouth Reconstruction",
              ].map((item) => (
                <a key={item} href="#" onClick={closeMobileMenu}>
                  {item}
                </a>
              ))}
            </div>
          )}

          <a href={`tel:${phone}`} onClick={closeMobileMenu}>
            Call Us
          </a>

          <button
            className="theme-toggle-btn mobile-theme-toggle"
            onClick={toggleTheme}
          >
            {theme === "dark" ? "☀️ Light Mode" : "🌙 Dark Mode"}
          </button>
        </div>
      )}
    </>
  );
}
